import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import { LanguageProvider } from "@/lib/i18n";
import LanguagePrompt from "@/components/LanguagePrompt";
import Analytics from "@/components/Analytics";
import "@/App.css";

import Home from "@/pages/Home";
import DirigeantsCodir from "@/pages/DirigeantsCodir";
import ManagementLeadership from "@/pages/ManagementLeadership";
import EcoleManagement from "@/pages/EcoleManagement";
import CooConseil from "@/pages/CooConseil";
import Seminaires from "@/pages/Seminaires";
import Pcm from "@/pages/Pcm";
import Rise from "@/pages/Rise";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Resources from "@/pages/Resources";
import Team from "@/pages/Team";
import Legal from "@/pages/Legal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminResources from "@/pages/admin/AdminResources";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminClients from "@/pages/admin/AdminClients";
import AdminReferences from "@/pages/admin/AdminReferences";
import AdminSettings from "@/pages/admin/AdminSettings";
import References from "@/pages/References";
import Status from "@/pages/Status";
import ArtDeLaPaix from "@/pages/ArtDeLaPaix";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <LanguageProvider>
            <AuthProvider>
            <ScrollToTop />
            <LanguagePrompt />
            <Analytics />
          <Routes>
            {/* Public site */}
            <Route path="/" element={<Home />} />
            <Route path="/dirigeants-codir" element={<DirigeantsCodir />} />
            <Route path="/management-leadership" element={<ManagementLeadership />} />
            <Route path="/ecole-management" element={<EcoleManagement />} />
            <Route path="/coo-conseil" element={<CooConseil />} />
            <Route path="/seminaires" element={<Seminaires />} />
            <Route path="/pcm" element={<Pcm />} />
            <Route path="/rise" element={<Rise />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/equipe" element={<Team />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/lets-rise" element={<Contact />} />
            <Route path="/letsrise" element={<Contact />} />
            <Route path="/ressources" element={<Resources />} />
            <Route path="/references" element={<References />} />
            <Route path="/artdelapaix" element={<ArtDeLaPaix />} />
            <Route path="/status" element={<Status />} />
            <Route path="/mentions-legales" element={<Legal />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="resources" element={<AdminResources />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="references" element={<AdminReferences />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>
          </Routes>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
